import * as types from '../../actions/actiontypes';
import {HttpStatusCodes} from '../../util/uiconstants';

export default function verticalNavigationReducer(state = null, action) {
	switch (action.type) {
		case types.GET_TASKS_WITH_BUILD_MILESTONE_ID: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.Ok) {
				let milestoneIdSet = new Set();
				let milestoneIdArray = [];
				action.response?.taskGroups?.forEach((taskGroup) => {
					taskGroup?.tasks?.forEach((task) => {
						if (!milestoneIdSet.has(task.taskBuildMilestoneId)) {
							milestoneIdSet.add(task.taskBuildMilestoneId);
							milestoneIdArray.push(task.taskBuildMilestoneId);
						}
					});
				});
				return {...state, ...action.response, milestoneIds: [...milestoneIdArray]};
			}
			return state;
		}
		case types.GET_GUIDANCE_LINKS_FOR_SUPER_MODAL: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.Ok) {
				let guidanceLinks = new Map(state?.guidanceLinks);
				guidanceLinks.set(action?.meta?.taskId, action?.response);
				return {...state, guidanceLinks: guidanceLinks};
			}
			return state;
		}
		case types.GET_TASK_DETAILS_FOR_SUPER_MODAL: {
			if (action.responseObj?.status && action.responseObj.status === HttpStatusCodes.Ok) {
				const {knowledgeTaskDescription, description, openTaskNotesCount} = action.response;
				return {
					...state,
					knowledgeTaskDescription,
					customizedTaskDescription: description,
					openTaskNotesCount
				};
			}
			return state;
		}
		case types.SET_SUPER_MODAL_QL: {
			return {...state, superModalQuickLinks: action.meta.quickLinksArray};
		}
		case types.SET_SUPER_MODAL_OPEN: {
			return {...state, isOpen: action.meta?.isOpen};
		}
		default: {
			return state;
		}
	}
}
